<template>
  <div class="menu-ponuka overflow-hidden">
    <ul class="our-menu nt5 cf nl4 nl5-l nr4 nr5-l">
      <template
        v-for="(categoriesGroup, categoryGroupIx) in [menuCategoriesFood, menuCategoriesDrinks]"
      >
        <div class="MenuCategoriesGroup">
          <div v-for="(category, i) in categoriesGroup" class="dib w-100 ph4 ph5-l mt5">
            <smp-menu-category
              :title="isEnglish ? category.nameEn : category.name"
              :image="category.hasImg ? isEnglish ? `/images/menu/en/${ category['id'] }.png` : `/images/menu/${ category['id'] }.png` : null"
            >
              <smp-menu-item
                v-for="(menuItem, i) in menuItemsInCategory(category['id'])"
                :key="isEnglish ? menuItem.nameEn : menuItem.name"
                :name="isEnglish ? menuItem.nameEn : menuItem.name"
                :price="menuItem.price"
                :allergens="menuItem.allergens"
                :isLast="i % 2 === 1"
                :text="isEnglish ? menuItem.popisEn : menuItem.popis"
                :weight="menuItem.porcia"
                class="mt4 white"
              />
            </smp-menu-category>
          </div>
        </div>

        <div class="dn db-ns">
          <img
            v-if="categoryGroupIx === 0"
            class="img-responsive center ph5 pt6"
            :src="isEnglish ? '/images/menu/en/pitny-rezim.png' : '/images/menu/pitny-rezim.png'"
            alt="Pitný režim"
          >
        </div>

        <div class="dn-ns">
          <img
            v-if="categoryGroupIx === 0"
            class="img-responsive center ph5 pt6"
            :src="isEnglish ? '/images/menu/en/pitny-rezim-mobile.png' : '/images/menu/pitny-rezim-mobile.png'"
            alt="Pitný režim"
          >
        </div>
      </template>
    </ul>
  </div>
</template>

<script>
import SmpMenuItem from '@/components/MenuItem'
import SmpMenuCategory from '@/components/MenuCategory'

export default {
    components: {
      SmpMenuCategory,
      SmpMenuItem,
    },

    props: {
      isEnglish: Boolean
    },

    data () {
      return {
        menu: [...__INITIAL_STATE__.menu || []],
        menuCategories: [...__INITIAL_STATE__.menuCategories || []],
      }
    },

    computed: {
      menuCategoriesFood () {
        const firstDrinkCategoryIndex = this.menuCategories.findIndex(x => x['id'] === 'degustacia-piv')
        return firstDrinkCategoryIndex < 0
          ? [...this.menuCategories]
          : this.menuCategories.slice(0, firstDrinkCategoryIndex - 1)
      },

      menuCategoriesDrinks () {
        const firstDrinkCategoryIndex = this.menuCategories.findIndex(x => x['id'] === 'degustacia-piv')
        return firstDrinkCategoryIndex < 0
          ? []
          : this.menuCategories.slice(firstDrinkCategoryIndex)
      },
    },

    methods: {
      menuItemsInCategory (categoryId) {
        return this.menu.filter(x => x.category === categoryId)
      },
    },

  }
</script>

<style>
  @media (min-width: 992px) {
    .MenuCategoriesGroup {
      column-count: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuOffer.vue?b20b5fb4